export const themeVars = {
    '$color-white': '#fff',
    '$color-black': '#000',
    '$color-grey': '#aeb0b3',
    '$color-grey-light': '#ededed',
    '$color-border': '#bababa',
    '$font-size-xsmall': '12px',
    '$font-size-small': '14px',
    '$font-size-regular': '16px',
    '$font-size-large': '18px',
    '$font-size-xlarge': '22px',
    '$color-pie-palette-01': '#00a758',
    '$color-pie-palette-02': '#0000c1',
    '$color-pie-palette-03': '#ec6453',
    '$color-pie-palette-04': '#260b42',
    '$color-pie-palette-05': '#ce7612',
    '$color-pie-palette-06': '#08a298',
    '$color-pie-palette-07': '#c14a36',
    '$color-pie-palette-08': '#2d69ff',
    '$color-pie-palette-09': '#004427',
    '$color-pie-palette-10': '#8877ab',
    '$color-pie-palette-11': '#fcc457',
    '$color-table-border-bottom': '#bababa',
    '$window-max-width-mobile': '700px',
    '$window-min-width-not-mobile': '701px',
    '$window-max-width-tablet': '1000px',
};

export const variables = {
    '$color-white': '#fff',
    '$color-black': '#000',
    '$color-grey': '#aeb0b3',
    '$color-grey-light': '#ededed',
    '$color-grey-dark': '#616161',
    '$color-red': '#f00',
    '$font-size-x-small': '12px',
    '$font-size-xxx-small': '10px',
    '$font-size-small': '14px',
    '$font-size-regular': '16px',
    '$font-size-large': '18px',
    '$font-size-x-large': '22px',
    '$font-family-light': 'OpenSans_Light, sans-serif',
    '$font-family-regular': 'OpenSans_Regular, sans-serif',
    '$font-family-medium': 'OpenSans_Medium, sans-serif',
    '$font-family-semi-bold': 'OpenSans_SemiBold, sans-serif',
    '$font-family-bold': 'OpenSans_Bold, sans-serif',
    '$font-family-extra-bold': 'OpenSans_ExtraBold, sans-serif',
};
